import { useMediaQuery } from '@mui/material';

export default function useIsMobileResolution(): unknown {
  return useMediaQuery(`(max-width: 960px)`);
}
